var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/note-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7907 23.7831C15.1112 23.8577 15.1406 24.2775 14.8284 24.3816L12.985 24.9882C8.35336 26.4816 5.91503 25.2332 4.41003 20.6016L2.9167 15.9932C1.42337 11.3616 2.66003 8.91158 7.2917 7.41824L8.07236 7.15971C8.47523 7.02629 8.86478 7.42942 8.74597 7.83683C8.66203 8.12467 8.58239 8.42848 8.50503 8.74824L7.3617 13.6366C6.07836 19.1316 7.9567 22.1649 13.4517 23.4716L14.7907 23.7831Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.0317 4.2446L18.0833 3.7896C14.1867 2.86794 11.865 3.62627 10.5 6.4496C10.15 7.16127 9.87001 8.0246 9.63667 9.01627L8.49334 13.9046C7.35001 18.7813 8.85501 21.1846 13.72 22.3396L15.68 22.8063C16.3567 22.9696 16.9867 23.0746 17.57 23.1213C21.21 23.4713 23.1467 21.7679 24.1267 17.5563L25.27 12.6796C26.4133 7.80294 24.92 5.38794 20.0317 4.2446ZM17.8383 16.0513C17.7333 16.4479 17.3833 16.7046 16.9867 16.7046C16.9167 16.7046 16.8467 16.6929 16.765 16.6813L13.37 15.8179C12.9033 15.7013 12.6233 15.2229 12.74 14.7563C12.8567 14.2896 13.335 14.0096 13.8017 14.1263L17.1967 14.9896C17.675 15.1063 17.955 15.5846 17.8383 16.0513ZM21.2567 12.1079C21.1517 12.5046 20.8017 12.7613 20.405 12.7613C20.335 12.7613 20.265 12.7496 20.1833 12.7379L14.525 11.3029C14.0583 11.1863 13.7783 10.7079 13.895 10.2413C14.0117 9.7746 14.49 9.4946 14.9567 9.61127L20.615 11.0463C21.0933 11.1513 21.3733 11.6296 21.2567 12.1079Z",
    fill: "#787878"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.aa08ae34da7523ba63809f2b1c381f69.svg";
export { ForwardRef as ReactComponent };